const FEATURE_LEGACY_DOCUMENT_VAULT_DISABLED = 'LEGACY_DOCUMENT_VAULT_DISABLED';
const FEATURE_DOCUMENT_VAULT_FRA = 'DOCUMENT_VAULT';
const FEATURE_BUILDING_SAFETY_CASE = 'BUILDING_SAFETY_CASE';
const ACTION_LAST_ACTIVITY_DATE = 'ACTION_LAST_ACTIVITY_DATE';
const ACTIONS_DATE_REFERRED_TO_LEGAL = 'ACTIONS_DATE_REFERRED_TO_LEGAL';
const REDUCE_RISK_RATING = 'HAND_IN_SNAPSHOT_REDUCE_RISK_RATING';
const FEATURE_ACTION_FILES_DOCUMENT_VAULT = 'ACTION_FILES_DOCUMENT_VAULT';

export const ACTION_MGMT_BANNER_LEGACY_GLOBAL = 'ACTION_MGMT_BANNER_LEGACY_GLOBAL';
export const ACTION_MGMT_BANNER_LEGACY_RA = 'ACTION_MGMT_BANNER_LEGACY_RA';
export const ACTION_MGMT_BANNER_LEGACY_CLIENT = 'ACTION_MGMT_BANNER_LEGACY_CLIENT';

export const FEATURE_ACTION_FINDER = 'VUE_APP_FEATURE_ACTION_FINDER';

import {
  PROPERTIES_VIEW_PROPERTIES,
  DOCUMENT_VAULT_ACCESS,
  ACTIONS_VIEW_REG7_ACTIONS,
  BSC_VIEW_CASE,
  BSC_VIEW_ACTIONS,
  ACTIONS_VIEW_CLIENT_ACTIONS,
  ASSETS_VIEW_ASSETS_INVENTORY,
} from '@/config/permission';


export function isFeatureEnabled(feature) {
  return process.env[feature] === '1' || process.env[feature] === 'true';
}

export function isDocumentVaultEnabled(user) {
  const { features } = user || {};

  if (!Array.isArray(features) || features.length === 0) {
    return false;
  }

  return features.includes(FEATURE_LEGACY_DOCUMENT_VAULT_DISABLED);
}

export function isDocumentVaultFRAEnabled(user) {
  const { features } = user || {};

  if (!Array.isArray(features) || features.length === 0) {
    return false;
  }

  return features.includes(FEATURE_DOCUMENT_VAULT_FRA);
}

export function isBuildingSafetyCaseEnabled(user) {
  const { features } = user || {};

  if (!Array.isArray(features) || features.length === 0) {
    return false;
  }

  return features.includes(FEATURE_BUILDING_SAFETY_CASE);
}

export function isLastActivityDateEnabled(user) {
  const { features } = user || {};

  if (!Array.isArray(features) || features.length === 0) {
    return false;
  }

  return features.includes(ACTION_LAST_ACTIVITY_DATE);
}

export function isDateReferredToLegalEnabled(user) {
  const { features } = user || {};

  if (!Array.isArray(features) || features.length === 0) {
    return false;
  }

  return features.includes(ACTIONS_DATE_REFERRED_TO_LEGAL);
}

export function isReduceRiskRatingEnabled(user) {
  const { features } = user || {};
  if (!Array.isArray(features) || features.length === 0) {
    return false;
  }
  return features.includes(REDUCE_RISK_RATING);
}

export function isActionFilesDocumentVaultEnabled(user) {
  const { features } = user || {};
  if (!Array.isArray(features) || features.length === 0) {
    return false;
  }
  return features.includes(FEATURE_ACTION_FILES_DOCUMENT_VAULT);
}

export function isActionMgmtBannerEnabled(user, flag) {
  const { features } = user || {};

  if (!Array.isArray(features) || features.length === 0) {
    return false;
  }

  return features.includes(flag);
}

export function canUserAccessDocumentVault(user) {
  if (!isDocumentVaultEnabled(user)) {
    return false;
  }

  const permissions = user.roles.flatMap(r => r.permissions.map(p => p.name));

  if (!permissions.includes(PROPERTIES_VIEW_PROPERTIES) ||
    !permissions.includes(DOCUMENT_VAULT_ACCESS)) {
    return false;
  }

  return true;
}

export function canUserAccessDocumentVaultFRA(user) {
  if (!canUserAccessDocumentVault(user)) {
    return false;
  }

  if (!isDocumentVaultFRAEnabled(user)) {
    return false;
  }

  return true;
}

export function canUserAccessUrgentActions(user) {
  const permissions = user.roles.flatMap(r => r.permissions.map(p => p.name));

  return permissions.includes(ACTIONS_VIEW_REG7_ACTIONS);
}

export function canUserAccessBSC(user) {
  if (!isBuildingSafetyCaseEnabled(user)) {
    return false;
  }

  const permissions = user.roles.flatMap(r => r.permissions.map(p => p.name));

  return permissions.includes(BSC_VIEW_CASE);
}

export function canUserAccessClientActions(user) {
  const permissions = user.roles.flatMap(r => r.permissions.map(p => p.name));

  return permissions.includes(ACTIONS_VIEW_CLIENT_ACTIONS);
}

export function canUserAccessAssets(user) {
  const permissions = user.roles.flatMap(r => r.permissions.map(p => p.name));

  return permissions.includes(ASSETS_VIEW_ASSETS_INVENTORY);
}

